"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorVoiceCategory = exports.ActorVoiceAge = void 0;
var ActorVoiceAge;
(function (ActorVoiceAge) {
    ActorVoiceAge["YOUNG"] = "young";
    ActorVoiceAge["MIDDLE_AGED"] = "middle_aged";
    ActorVoiceAge["OLD"] = "old";
})(ActorVoiceAge || (exports.ActorVoiceAge = ActorVoiceAge = {}));
var ActorVoiceCategory;
(function (ActorVoiceCategory) {
    ActorVoiceCategory["PREMADE"] = "premade";
    ActorVoiceCategory["CLONED"] = "cloned";
    ActorVoiceCategory["GENERATED"] = "generated";
    ActorVoiceCategory["PROFESSIONAL"] = "professional";
})(ActorVoiceCategory || (exports.ActorVoiceCategory = ActorVoiceCategory = {}));
